module.exports = __webpack_public_path__ + "static/media/redesign-logo.4b389fb0.webp";